// Independent of A-F CCMR — do not import Ccmr/* or write ccmrIndicators*.
//
// Pure, side-effect-free display helpers for the CCMR Outcomes Bonus screen. None of
// these recompute funding (the backend aggregator is authoritative) — they only label,
// format, and shape already-computed values for the UI and the CSV export.

// Funding fiscal year is written span-form FY(gradYear+1)-(gradYear+2). The single
// integer gradYear+2 denotes the ENDING year of that span. Class of 2024 -> 'FY2025-26'.
export const fyLabel = (gradYear) => {
  const y = Number(gradYear);
  if (!Number.isFinite(y)) return '';
  return `FY${y + 1}-${String(y + 2).slice(-2)}`;
};

// SpEd rate is keyed off the grad class year, not the upload/funding year: $4,000 from
// Class of 2024 (HB2 §48.110, equivalent to funding FY25-26+), $2,000 for Class of 2023
// and earlier. Mirrors the backend aggregator's rate selection.
export const spedRate = (gradYear) => (Number(gradYear) >= 2024 ? 4000 : 2000);

// Cohort display metadata for the three funding cards, keyed by the byBand keys the
// aggregator emits.
export const COHORT_LABELS = {
  eco: { title: 'Econ Disadvantaged', thresholdPct: 11 },
  nonEco: { title: 'Non-Econ Disadv', thresholdPct: 24 },
  sped: { title: 'Special Education', thresholdPct: 0 },
};

export const COHORT_ORDER = ['eco', 'nonEco', 'sped'];

// US dollar formatting for headline + card figures.
export const formatDollars = (value) => {
  const n = Number(value) || 0;
  return `$${n.toLocaleString('en-US')}`;
};

const BAND_FULL_LABEL = {
  eco: 'Economically Disadvantaged',
  nonEco: 'Non-Economically Disadvantaged',
  sped: 'Special Education',
};

// Human-readable cohort membership for a near-qualifier row (bands is the array of band
// keys the student belongs to).
export const bandsLabel = (bands) => (bands || []).map((band) => BAND_FULL_LABEL[band] || band).join(', ');

// Shape near-qualifier worklist rows into flat objects for the CSV export. Mirrors the
// on-screen columns (Student, Local ID, Campus, Cohort(s), Missing indicator, Marginal $,
// Stacked $9,000). No PII beyond the name/local id already on the node — never SSN.
export const NEAR_QUALIFIER_CSV_COLUMNS = [
  { key: 'studentName', header: 'Student' },
  { key: 'localId', header: 'Local ID' },
  { key: 'campusName', header: 'Campus' },
  { key: 'cohorts', header: 'Cohort(s)' },
  { key: 'missing', header: 'Missing indicator(s)' },
  { key: 'marginalDollars', header: 'Marginal $' },
  { key: 'stacked9000', header: 'Stacked $9,000' },
];

export const shapeNearQualifierForCsv = (row) => ({
  studentName: row.studentName || '',
  localId: row.localId || '',
  campusName: row.campusName || row.campus || '',
  cohorts: bandsLabel(row.bands),
  missing: (row.missing || []).join('; '),
  marginalDollars: row.marginalDollars != null ? row.marginalDollars : 0,
  stacked9000: row.stacked9000 ? 'Yes' : '',
});

export default 'outcomesBonus.selectors.js';
